// extracted by mini-css-extract-plugin
export default {"dashboard":"DefaultLayout_dashboard__VPrsh","contentWrapper":"DefaultLayout_contentWrapper__e6HBK","mainContent":"DefaultLayout_mainContent__FRne7"};